export interface MissingCycleTimeItem {
    productId: string | null;
    productCollectionId?: string | null;
    productName?: string | null;
    productCode?: string | null;
    count?: number;
    workplaceCodes?: string[];
}

const key = (p: string | null) => `${p ?? ''}`;

const missingMap: Map<string, MissingCycleTimeItem> = new Map();
const listeners = new Set<() => void>();
function notify(): void {
    for (const fn of listeners) {
        try {
            fn();
        } catch {
            /* ignore */
        }
    }
}

export function resetMissingCycleTimes(): void {
    missingMap.clear();
    notify();
}

export function reportMissingCycleTime(item: MissingCycleTimeItem): void {
    const k = key(item.productId ?? null);
    const ex = missingMap.get(k);
    if (ex) {
        ex.count = (ex.count || 0) + (item.count || 1);
        // Prefer non-empty names
        if (!ex.productName && item.productName) ex.productName = item.productName;
        if (!ex.productCode && item.productCode) ex.productCode = item.productCode;

        // Sbíráme všechny workplaceCodes
        if (!ex.workplaceCodes) ex.workplaceCodes = [];

        if (item.workplaceCodes) {
            for (const wpCode of item.workplaceCodes) {
                if (wpCode && !ex.workplaceCodes.includes(wpCode)) {
                    ex.workplaceCodes.push(wpCode);
                }
            }
        }

        missingMap.set(k, ex);
    } else {
        const newItem = { ...item, count: item.count || 1 };
        // Inicializuj pole, pokud není nastaveno
        if (!newItem.workplaceCodes) {
            newItem.workplaceCodes = item.workplaceCodes || [];
        }
        missingMap.set(k, newItem);
    }
    notify();
}

export function getMissingCycleTimes(): MissingCycleTimeItem[] {
    return Array.from(missingMap.values());
}

export function onMissingCycleTimesChanged(cb: () => void): () => void {
    listeners.add(cb);
    return () => listeners.delete(cb);
}
